import { generateGraffitiCardSpecification } from "../../Core/GraffitiCard/spec";

export const specification = generateGraffitiCardSpecification("Retail J1 Card", "https://main.d1jr7od1rvg76b.amplifyapp.com/cards", "https://main.d14zew3lt4ghz0.amplifyapp.com/cards", "J1");
